<template>
    <div class="tw-p-2 tw-flex" style="border: 1px solid #aaa; border-radius: 3px;">
        <div>
                <TAutoComplete
                    class="tw-w-80"
                    :items="fieldChoices"
                    :display="val => (val || '').split(':')[0]"
                    v-model="rawField"
                    @update:modelValue="val => fieldSelect(val)"    
                ></TAutoComplete>
        </div>
        <TSimplePicker
            buttonClass="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
            :modelValue="value.op"
            @update:modelValue="val => updateRule('op', val)"
            class="tw-mx-4"
            :items="filteredOps"
            :format="val => val.label"
        ></TSimplePicker>
        <div class="">
            <div v-if='this.value && this.value.field'>
            <component 
                :is="fieldTypeInput"
                :value="convertValue(value.value, this.value.field)"
                :op="value.op"
                @input="val => updateRule('value', val)"
                ></component>
            </div>
        </div>
        <div class='tw-ml-4'>
            <span v-show='removable' @click="$emit('remove')" class='mdi mdi-close' type='is-danger is-clickable'></span>
        </div>
    </div>
</template>


<script>

import StringInput    from './StringInput.vue'
import FloatInput     from './FloatInput.vue'
import BooleanInput   from './BooleanInput.vue'
import IntegerInput   from './IntegerInput.vue'
import TimestampInput from './TimestampInput.vue'

import TAutoComplete from '@/components/TAutoComplete.vue'

import {
    TSimplePicker
} from '@roonlabs/vue-tailwind'


export default {
    name: 'SimpleRule', components: {TAutoComplete, TSimplePicker, StringInput,BooleanInput,IntegerInput,FloatInput,TimestampInput},
    props: {
        value: Object,
        removable: Boolean,
        store: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            default: 'e.g. user_id'
        }
    },
    data() {
        return {
            rawField: ''
        }
    },
    watch: {
        'value.field': {
            deep: true,
            handler(newVal) {
                if (newVal !== "" && newVal !== undefined && newVal != null) {
                    newVal = newVal.split(':')[0];
                    if ( newVal && this.rawField != newVal)
                        this.rawField = newVal;
                }
            }
        }
    },
    methods: {
        fieldBlur(active) {
            if (active)
                this.$refs.input.toggle();

            setTimeout(() => {
                if (!this.value.field.startsWith(this.rawField + ":")) {
                    this.rawField = "";
                    this.$emit("input", {
                        ...this.value,
                        field: null,
                        value: this.convertValue(null, null)
                    })
                }
            }, 200);
        },

        fieldSelect(val) {
            //console.log("SELECTED FIELD", val, "VALUE IS RESRT TO", this.convertValue(null, val))
            this.$emit("input", {
                ...this.value,
                field: val,
                value: this.convertValue(null, val)
            })
        },
        fieldFocus() {
            const end = this.$refs.rawInput.value.length;
            this.$refs.rawInput.setSelectionRange(0, end);
            this.$refs.rawInput.focus();
        },
        convertValue(val, field) {
            if (!field) return undefined;

            const type = field.split(':')[1];
            switch (type) {
                case 'STRING':    return val === null || val === undefined ? "" : val.toString();
                case 'BOOLEAN':   return !!val;
                case 'INTEGER':   return Number(val ?? 0).toFixed(0);
                case 'FLOAT':     return Number(val ?? 0.0);
                case 'TIMESTAMP': return val;
                default: throw 'ah'
            }
        },
        updateRule(prop, val) {
            this.$emit("input", {
                ...this.value,
                [prop]:val
            })
        },
    },
    computed: {
        fieldChoices() {
            return this.store.fields;
        },

        loading() {
            return this.store.fields_loading;
        },

        filteredFieldChoices() {
            return this.fieldChoices.filter((option) => {
                if (this.rawField) {
                    const rf = this.rawField.toLowerCase();
                    const lc = option.split(':')[0].toLowerCase();

                    return lc.indexOf(rf) >= 0;
                } else {
                    return true;
                }
            });
        },

        filteredOps() {
            return [
                {
                    value: 'is_null',
                    label: 'Is Empty',
                    types: ['INTEGER', 'TIMESTAMP']
                },
                {
                    value: 'is_not_null',
                    label: 'Is Not Empty',
                    types: ['TIMESTAMP']
                },
                {
                    value: '==',
                    label: 'is',
                    types: ['BOOLEAN', 'STRING', 'INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: '!=',
                    label: 'is not',
                    types: ['BOOLEAN', 'STRING', 'INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: '<',
                    label: '<',
                    types: ['INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: '<=',
                    label: '<=',
                    types: ['INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: '>',
                    label: '>',
                    types: ['INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: '>=',
                    label: '>=',
                    types: ['INTEGER', 'TIMESTAMP', 'FLOAT']
                },
                {
                    value: 'starts_with',
                    label: 'starts with',
                    types: ['STRING']
                },
                {
                    value: 'ends_with',
                    label: 'ends with',
                    types: ['STRING']
                },
            ].filter(v => {
                if (this.store.fieldOps) {
                    const ops = new Set(this.store.fieldOps[this.value?.field] || [])
                    return ops.has(v.value);
                }
                return v.types.includes(this.value?.field?.split(':')[1])
            })
        },


        fieldTypeInput() {
            if (!this.value.field) return'';

            const type = this.value.field.split(':')[1];
            switch (type) {
                case 'STRING':    return 'StringInput'
                case 'BOOLEAN':   return 'BooleanInput'
                case 'INTEGER':   return 'IntegerInput'
                case 'FLOAT':     return 'FloatInput'
                case 'TIMESTAMP': return 'TimestampInput'
                default: throw 'ah'
            }
        },
    },

    created() {
        this.store.getFields();
        if ( this.value?.field ) {
            this.rawField = this.value.field.split(':')[0]
        }
    }
}
</script>
